import type { CourseMode } from '@/features/courses/types'
import { useTranslation } from 'react-i18next'

interface RAGIndicatorProps {
  mode: CourseMode
  readyDocumentsCount: number
}

export function RAGIndicator({ mode, readyDocumentsCount }: RAGIndicatorProps) {
  const { t } = useTranslation()
  if (mode === 'free') return null

  return (
    <div
      className="flex items-center gap-2 shrink-0 px-3 py-2 border-b"
      style={{
        backgroundColor: 'var(--color-primary-subtle)',
        borderColor: 'var(--color-primary-light)',
      }}
      role="status"
      aria-live="polite"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
        fill="currentColor"
        aria-hidden="true"
        style={{ width: 14, height: 14, color: 'var(--color-primary)', flexShrink: 0 }}
      >
        <path
          fillRule="evenodd"
          d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H7z"
          clipRule="evenodd"
        />
      </svg>
      <span
        style={{
          fontSize: '12px',
          color: 'var(--color-primary)',
          lineHeight: '1.4',
        }}
      >
        {t('session.rag_active', { count: readyDocumentsCount })}
      </span>
    </div>
  )
}
